module.exports = __webpack_public_path__ + "static/media/map_marker.823af460.svg";